import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuftragsKomponente } from 'src/app/api/model/swagger-model';
import { Auftragdetails } from '../auftragdetails.helper';
import { KomponenteBase } from './komponente';

@Component({
    selector: 'fahrzeug-kennzeichen-komponente',
    template: `
        <div class="section section-no-padding" *ngIf="auftrag.FahrzeugKennung">
            <div class="fahrzeug">
            <div class="kennzeichen"><span class="blau"><img src="assets/img/euro-sterne-28.png" /></span><span class="kennzeichen-text">{{ auftrag.FahrzeugKennung }}</span></div>
            </div>
        </div>
    `,
    styles: [`
        .kennzeichen {
            margin-top: 0;
        }
    `],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AuftragFahrzeugKennzeichenComponent extends KomponenteBase implements OnInit {

    @Input() auftragdetails: Auftragdetails;
    @Input() komponente: AuftragsKomponente;

    constructor(
        private router: Router,
        protected cdr: ChangeDetectorRef) {
        super(cdr);
    }

    ngOnInit() {
        super.ngOnInit();
    }
}
